// Нативный слой Telegram: тактильная отдача и цвета хрома клиента.
//
// Всё здесь молча ничего не делает вне Telegram и на старых клиентах: один и тот
// же бандл работает как Mini App и как сайт, а половина методов появилась в
// версиях 7.x. Поэтому каждый вызов — через `?.` и try/catch: тактильная отдача
// приятна, но ронять из-за неё экран нельзя.

export function tg() {
  return window.Telegram?.WebApp;
}

function safe(fn: () => void): void {
  try {
    fn();
  } catch {
    /* старый клиент или не Telegram — молча пропускаем */
  }
}

/**
 * Тактильная отдача. Правило простое: `select` — на переключении (табы, чипы),
 * `tap` — на действии без последствий (лайк, листание), `success`/`error` — на
 * результате операции с сервером. Больше видов не заводим: вибрация на каждый
 * чих раздражает сильнее, чем её отсутствие.
 */
export const haptic = {
  tap: () => safe(() => tg()?.HapticFeedback?.impactOccurred?.("light")),
  press: () => safe(() => tg()?.HapticFeedback?.impactOccurred?.("medium")),
  select: () => safe(() => tg()?.HapticFeedback?.selectionChanged?.()),
  success: () => safe(() => tg()?.HapticFeedback?.notificationOccurred?.("success")),
  error: () => safe(() => tg()?.HapticFeedback?.notificationOccurred?.("error")),
};

/** Текущее значение CSS-переменной темы в виде hex/rgb-строки. */
export function cssVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

/**
 * Подгоняет хром клиента под наш лист бумаги.
 *
 * Палитра у приложения своя (оно же работает сайтом), поэтому цвет берём из
 * CSS-переменной, а не из ключа темы Telegram: иначе при нашей тёмной теме
 * шапка осталась бы светлой — там своя тема, независимая от нашей.
 *
 * Вызывать после каждой смены темы: клиент запоминает последнее значение.
 */
export function applyTelegramChrome(): void {
  const w = tg();
  if (!w) return;
  const bg = cssVar("--bg");
  if (!bg) return;
  safe(() => w.setBackgroundColor?.(bg));
  safe(() => w.setHeaderColor?.(bg));
  safe(() => w.setBottomBarColor?.(bg));
}

/**
 * Отключает закрытие приложения свайпом вниз по контенту.
 *
 * Без этого на карточке товара горизонтальное листание фото и pull-to-refresh в
 * каталоге регулярно схлопывают Mini App: клиент считает жест попыткой закрыть.
 * Метод есть с 7.7 — на старых клиентах просто нет.
 */
export function lockVerticalSwipes(): void {
  safe(() => tg()?.disableVerticalSwipes?.());
}
